import type { SalesChannel, SalesChannelConfiguration } from '@vista-digital/lumos-cms-client'
import { getFetchedDataPayload } from '@vista-digital/utilities'
import { domainStores } from './domain-stores'

export const getSalesChannelConfiguration = (): SalesChannelConfiguration<SalesChannel.Web> | undefined => {
    return getFetchedDataPayload(domainStores.configuration.data.configuration)
}
